import { IBranch } from "../@types/branch";
import axios from "../axiosInstance";

export const getBranches = async () => {
  try {
    let response = await axios.get("/api/branch-hierarchy");
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getDistricts = async () => {
  try {
    let response = await axios.get("/api/branch-hierarchy");
    const data: IBranch[] = response.data.branchHierarchy;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getBranch = async (branchId: number) => {
  try {
    let response = await axios.get(`/api/branch-hierarchy/:${branchId}`);
    const data: IBranch = response.data.branch;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateBranch = async (initial: IBranch) => {
  try {
    const response = await axios.put("/api/branch-hierarchy", initial);
    const data: IBranch = response.data.branch;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const createBranch = async (initial: IBranch) => {
  try {
    let response = await axios.post("/api/branch-hierarchy", initial);
    const data: IBranch = response.data.branch;
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const setActivationForBranch = async (branchId: number) => {
  try {
    const response = await axios.put(
      "/api/branch-hierarchy/activation",
      branchId
    );
    const data: number = response.data.item;
    return data;
  } catch (error) {
    console.error(error);
  }
};
